<!--
 * @Description:
 * @Author: luokang
 * @Date: 2023-12-11 15:43:54
-->
<template>
    <div class='step_one'>
      <div class="step_one_content">
        <p>{{ $lang('下载并安装验证应用') }}</p>
        <p>{{ $lang('你可以在手机 APP Store 或应用市场中，下载Google Authenticator、Authenticator 或 手机令牌 等验证应用') }}</p>
      </div>
    </div>
</template>
<script>

export default {
  components: {},
  props: {},
  name: 'StepOne',
  data() {
    return {

    }
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  }
}
</script>
<style scoped lang='scss'>
 /* @import url(); 引入css类 */
 .step_one{
    height: 466px;
    display: grid;
    place-content: center;
    .step_one_content{
     p:nth-child(1){
       font-size: 16px;
       font-family: PingFang SC, PingFang SC-Medium;
       font-weight: Medium;
       text-align: center;
       color: #1f1f1f;
       line-height: 22px;
       margin-bottom: 16px;
     }
     p:nth-child(2){
       font-size: 14px;
       font-family: PingFang SC, PingFang SC-Regular;
       font-weight: Regular;
       text-align: center;
       color: #7a7a7a;
       line-height: 20px;
     }
    }
 }
</style>
